import React from "react";

export const About = (props) => {
  return (
    <div>
      <h1>About</h1>
    </div>
  );
};
